import React from "react";
import { Typography, Link, Box, Stack } from "@mui/material";
import { AnimatedOnScroll } from "react-animated-css-onscroll";
import brokenImg from "../Asset/images/broken-images.png";

export default function CardCategories({
  type = "categories",
  match,
  ...props
}) {
  const { id, logo_full_path, name, company_name } = props.data;
  return (
    <AnimatedOnScroll animationIn="fadeInRightBig" animationInDuration={600}>
      <Stack direction={`${type === "categories" ? "column" : "row"}`}>
        {/* <Stack direction='row'> */}
        <Link href={`/detail/${id}`}>
          <Box
            sx={{
              backgroundColor: "#fff",
              width: {
                lg: "150px",
                md: "125px",
                xs: "90px",
              },
              height: {
                lg: "150px",
                md: "125px",
                xs: "90px",
              },
              borderRadius: 5,
              boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
            }}
          >
            <Box
              component="img"
              sx={{
                backgroundColor: "#fff",
                width: {
                  lg: "100%",
                  md: "125px",
                  xs: "100%",
                },
                height: {
                  lg: "auto",
                  md: "125px",
                  xs: "auto",
                },
                position: "relative",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                borderRadius: 5,
              }}
              src={logo_full_path || brokenImg}
              alt={name}
            />
          </Box>
        </Link>
        {type === "categories" && (
          <>
            <Box sx={{ width: "100%", mt: "20px" }}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  color: "#2d3436",
                  fontSize: 14,
                }}
              >
                {name}
              </Typography>
            </Box>
            <Box sx={{ width: "100%" }}>
              <Typography
                variant="body3"
                sx={{ fontSize: 12, color: "#2d3436" }}
              >
                {company_name || "PT. Mcash Integrasi, Tbk"}
              </Typography>
            </Box>
          </>
        )}
      </Stack>
    </AnimatedOnScroll>
  );
}
